import { Link, useLocation } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();
  usePageMeta({
    title: "页面未找到 - 秋霞影院",
    description: "抱歉，你访问的页面不存在或已被移除，请返回秋霞影院首页继续浏览影视作品与资讯。",
    keywords: "秋霞影院,404,页面未找到",
  });

  return (
    <div className="mx-auto flex w-full max-w-[1400px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-3xl text-foreground-400">
        <i className="ri-emotion-sad-line" />
      </span>
      <p className="mt-5 font-heading text-5xl font-black text-primary-200 md:text-7xl">404</p>
      <h1 className="mt-2 font-heading text-2xl font-bold text-foreground-950">页面走丢了</h1>
      <p className="mt-2 text-sm text-foreground-500">
        抱歉，你访问的页面 <span className="font-mono text-foreground-700">{location.pathname}</span> 不存在或已被移除
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-700"
        >
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400"
        >
          浏览电影专区
        </Link>
        <Link
          to="/news"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400"
        >
          查看影视资讯
        </Link>
      </div>
    </div>
  );
}